<template>
    <div class="breadcrumb">
        <div class="flex-1">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <span class="home_bm" @click="goHome">首页</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item v-for="item in breadcrumblist" :key="item.meta.title"
                    v-if="$route.meta.title != '首页'">
                    <span :class="item.name?'home_bm':''" @click="openPath
                        (item.name)">{{ item.meta.title }}
                    </span>
                </el-breadcrumb-item>
                <!-- <el-breadcrumb-item v-if="$route.meta.title != '首页'">{{ $route.meta.title }}</el-breadcrumb-item> -->
            </el-breadcrumb>
        </div>
        <div class="right_box">
            <div class="right_cell" @click="refreshPage">
                <i class="el-icon-refresh-right"></i>
                <div class="f-13">刷新</div>
            </div>
            <div class="right_cell" @click="exit">
                <i class="el-icon-switch-button"></i>
                <div class="f-13">退出</div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    computed: {
        breadcrumblist() {
            return this.$route.matched
        },
    },
    data() {
        return {
            list: [],
        }
    },
    created() {

    },

    methods: {
        goHome() {
            if (this.$route.name != 'Home') {
                this.$router.push({
                    name: 'Home',
                    params: { url: 'Home', scene: new Date().getTime() }
                })
            }
        },
        openPath(name, redirect) {
            if (name) {
                if (this.$route.name != name) {
                    this.$router.push({
                        name: name,
                        params: { url: name, scene: new Date().getTime() }
                    })
                }
            }
        },
        refreshPage() {
            location.reload();
        },
        exit() {
            this.$confirm('确认退出当前账号吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                localStorage.clear()
                location.reload();
            }).catch(() => { });

        }
    }
}
</script>

<style scoped lang="scss">
.breadcrumb {
    height: 55px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    padding: 0 20px;
    background-color: #ffffff;
    border-bottom: 1px solid #eaeaea;

    .home_bm {
        cursor: pointer;
    }

    .right_box {
        display: flex;
        align-items: center;

        .right_cell {
            cursor: pointer;
            text-align: center;
            margin-left: 30px;
        }
    }
}
</style>
